import React from "react";

const AboutUsCard = ({ ...props }) => {
  return <div className="shadow-none w-100 m-0 fadeIn">{props.children}</div>;
};

export default AboutUsCard;
